import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input, ViewEncapsulation } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

@Component({
	selector: "obg-m-deposit-limit-calculator-info-modal.component",
	templateUrl: "./deposit-limit-calculator-info-modal.component.html",
	styleUrls: ["./deposit-limit-calculator-info-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DepositLimitCalculatorInfoModalComponent {
	@HostBinding("class.obg-m-deposit-limit-calculator-info-modal") class = true;

	@Input() dialogId: string | undefined;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: string | undefined,
		private dialogRef: MatDialogRef<DepositLimitCalculatorInfoModalComponent>
	) {}

	closeDialog() {
		this.dialogRef.close();
	}
}
